<template>
  <div>
    <el-row>
      <el-col v-for="(algorithmItem,algorithmKey) in propsAlgorithm" :key="algorithmKey" :span="colSpan">
        <div>
          <b :style="`${algorithmKey===0?'':'text-decoration: line-through;'}`">费用计算公式({{
              algorithmItem.date
            }})：</b>
          <div>
            <ol>
              <li v-for="(item,index) in algorithmItem.data" :key="index">
                <span v-html="item"></span>
              </li>
            </ol>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {algorithm} from "@/views/adOrder/algorithm";

export default {
  name: "algorithm",
  props: {
    propsAlgorithm: {
      type: Array,
      default() {
        return algorithm
      }
    },
    colSpan: {
      type: Number,
      default() {
        return 8
      }
    }
  },
  data() {
    return {algorithm}
  }
}
</script>

<style scoped>

</style>
